const a = () => {
  const o = window.location.hostname;
  if (o === "localhost")
    return "localhost";
  const t = o.endsWith(".co.uk") ? -3 : -2;
  return `.${o.split(".").slice(t).join(".")}`;
};
export {
  a as default
};
